import {defineStore} from "pinia";
import {api} from "@/services/api.ts";
import {BaseHeader} from "@/types/common.ts";

export const useCommonStore = defineStore("common-store", {
  state: () => ({
    sectionHeader: null as BaseHeader | null,
    nextIds: [] as string[],
    isFetchingIds: false,
  }),
  actions: {
    setSectionHeader(value: BaseHeader | null) {
      this.sectionHeader = value;
    },
    async fetchNextIds() {
      if (this.isFetchingIds)
        return;
      this.isFetchingIds = true;
      try {
        const ids = await api.admin.generateNextIds();
        this.nextIds.push(...ids);
      } finally {
        this.isFetchingIds = false;
      }
    },
    async getNextId(): Promise<string> {
      if (this.nextIds.length === 0) {
        await this.fetchNextIds(); // wait if completely empty
      }
      if (this.nextIds.length <= 5 && !this.isFetchingIds) {
        this.fetchNextIds(); // preload in background (no await)
      }
      const id = this.nextIds.shift();
      if (!id)
        throw new Error("غير قادر علي إنشاء معرف");

      return id;
    }
  },
  getters: {
    getSectionHeader(): BaseHeader | null {
      return this.sectionHeader
    }
  }
})